import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/sales/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const salesService = {
  listSales: (filterField = null, filterValue = null, sortBy = '-created_at', page = 1, createdFrom = null, createdTo = null) => {
    const params = {
      sort_by: sortBy,
      page: page
    };
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }
    if (createdFrom) {
      params.created_from = createdFrom;
    }
    if (createdTo) {
      params.created_to = createdTo;
    }
    return axios.get(BASE_URL, {
      headers: getHeaders(),
      params
    });
  },

  getSaleById: (id) => {
    return axios.get(`${BASE_URL}${id}/`, {
      headers: getHeaders()
    });
  },

  cancelSale: (id) => {
    return axios.post(`${BASE_URL}${id}/cancel/`, {}, {
      headers: getHeaders()
    });
  },

  markSalePaid: (id, payload) => {
    return axios.post(`${BASE_URL}${id}/mark_paid/`, payload, {
      headers: getHeaders()
    });
  },

  markInvoiced: (id) => {
    return axios.post(`${BASE_URL}${id}/mark_invoiced/`, {}, {
      headers: getHeaders()
    });
  }
};

export default salesService;
